import OrderList from '@pages/admin/store-management/order/lists'
import React from 'react'

const StoreOrders = ({ user }: any) => {
  return <OrderList userId={user.id} />
}

export default StoreOrders
